// material
import { Avatar, Box, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material'
import { styled } from '@mui/material/styles'
// @types
import { IStaff } from 'types/user'
// ----------------------------------------------------------------------

const AVATAR_SIZE = 48
const AVATAR_SIZE_GROUP = 32

const RootStyle = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(1.5, 3),
  transition: theme.transitions.create('all')
}))

const AvatarWrapperStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
  '& .MuiAvatar-img': { borderRadius: '50%' },
  '& .MuiAvatar-root': { width: '100%', height: '100%' }
}))

// ----------------------------------------------------------------------

type StaffItemProps = {
  isSelected: boolean
  staff: IStaff
  isOpenSidebar: boolean
  onSelectStaff: () => void
}

export default function StaffItem({
  isSelected,
  staff,
  isOpenSidebar,
  onSelectStaff
}: StaffItemProps) {
  return (
    <RootStyle
      onClick={onSelectStaff}
      sx={{
        ...(isSelected && { bgcolor: '#eff9f3' })
      }}
    >
      <ListItemAvatar>
        <Box
          sx={{
            ...{
              position: 'relative',
              width: AVATAR_SIZE,
              height: AVATAR_SIZE,
              '& .avatarWrapper': {
                position: 'absolute',
                width: AVATAR_SIZE_GROUP,
                height: AVATAR_SIZE_GROUP,
                '&:nth-of-type(1)': {
                  left: 0,
                  zIndex: 9,
                  bottom: 2,
                  '& .MuiAvatar-root': {
                    border: (theme) => `solid 2px ${theme.palette.background.paper}`
                  }
                },
                '&:nth-of-type(2)': { top: 2, right: 0 }
              }
            }
          }}
        >
          {/* <AvatarWrapperStyle className="avatarWrapper" key={staff.id}> */}
          <Avatar
            alt={staff.email}
            src={staff.picture}
            sx={{ cursor: 'pointer', width: 48, height: 48 }}
          />
          {/* </AvatarWrapperStyle> */}
        </Box>
      </ListItemAvatar>

      {isOpenSidebar && (
        <>
          <ListItemText
            primary={staff.name}
            primaryTypographyProps={{
              noWrap: true,
              variant: 'subtitle2',
              color: `${isSelected ? '#37aa54' : 'text.secondary'}`
            }}
            secondary={staff.email}
            secondaryTypographyProps={{
              noWrap: true,
              variant: 'body2',
              color: 'textSecondary'
            }}
          />
        </>
      )}
    </RootStyle>
  )
}
